import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import aboutImage from "../../../../assets/images/Travel/aboutus.png";
import TravelLinkService from "../../../../services/TravelLinkService/TravelLinkService";
import { Link } from "react-router-dom";

const About = ({ homeData }) => {
  return (
    <>
      <Row className="mb-5 p-0">
        <Col xs={12} md={6} lg={6} className="d-flex justify-content-start mb-2">
          <img
            src={homeData?.about?.page_image_url}
            className="img-fluid rounded object-fit-cover"
            alt="Nepal & the Himalayas"
          />
        </Col>
        <Col xs={12} md={6} lg={6}>
          <h1 className=" fw-600">{homeData?.about?.name}</h1>
          <p
            dangerouslySetInnerHTML={{
              __html: homeData?.about?.short_description,
            }}
          />

          {/* <button className="btn btn-outline-info"> */}
          <Link to="/about-us" className="btn btn-outline-info">
            Learn More
          </Link>
          {/* </button> */}
        </Col>
      </Row>
    </>
  );
};

export default About;
